<h1 mat-dialog-title>Eintrag löschen</h1>
<div mat-dialog-content>Möchten Sie den Eintrag sicher löschen?</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Nein</button>
  <button mat-button (click)="onYesClick()" cdkFocusInitial>Ja</button>
</div>
